export const SET_IS_ONBOARDING_OPEN = 'ONBOARDING/SET_IS_ONBOARDING_OPEN';
export const SET_IS_FROM_REGISTRATION = 'ONBOARDING/SET_IS_FROM_REGISTRATION';
export const ADD_SEEN_ROUTE = 'ONBOARDING/ADD_SEEN_ROUTE';
